import { EventType } from '../domain/webhook/EventType';
import { Webhook } from '../domain/webhook/Webhook';
import { webhookRepository } from '../repositories/webhook';
import { WebhookRepository } from '../repositories/webhook/WebhookRepository';

export class WebhookService {
  constructor(private webhookRepository: WebhookRepository) {}
  async retrieveWebhooks(projectId: string): Promise<Webhook[]> {
    const response = await this.webhookRepository.retrieve(projectId);
    return response;
  }
  async createWebhook(webhook: Webhook, projectId: string): Promise<Webhook> {
    const response = await this.webhookRepository.create(webhook, projectId);
    return response;
  }
  async updateWebhook(webhook: Webhook): Promise<Webhook> {
    const response = await this.webhookRepository.save(webhook);
    return response;
  }
  async deleteWebhook(webhook: Webhook): Promise<Webhook> {
    await this.webhookRepository.delete(webhook);
    return webhook;
  }
  async testWebhook(webhook: Webhook, event: EventType): Promise<void> {
    await this.webhookRepository.test(webhook, event);
  }
}

export const webhookService = new WebhookService(webhookRepository);
